import React, { useEffect, useRef, useState } from "react";
import { Menu, Button } from "antd";
import type { MenuProps } from "antd";
import Parser from "html-react-parser";

import dataJson from "@/../public/data.json";

import "./index.less";
import { flatMapDepth } from "lodash-es";
const prefix = "moduleTabs";

type Porps = {
  tabActive: string | null;
  list: any[];
  isShowImg?: boolean;
};

const ModuleTabs: React.FC<Porps> = (props: Porps) => {
  const { tabActive, list,isShowImg = true } = props;

  const [active, setActive] = useState<string | null>(list[0].key);
  const [menu, setMenu] = useState<any[]>(list[0].menu);
  const [current, setCurrent] = useState<string>("");
  const [introduce, setIntroduce] = useState<string>("");
  const [emptyText, setEmptyText] = useState<string>("");
  const [introduceImg, setIntroduceImg] = useState<any>(null);
  const [btnList, setBtnList] = useState<any[]>([]);

  const { stay_tuned, ecological } = dataJson;

  const duplicate: any = (item: any) => {
    return item?.children?.length ? flatMapDepth(item?.children, duplicate, 1) : item;
  };

  const setData = (tabKey: string | null, menuKey?: string) => {
    const itemData = list.find((item: any) => item.key == tabKey);
    setEmptyText(itemData?.emptyText);
    setBtnList(itemData?.btns);
    const initMenu = itemData?.menu;
    setMenu(initMenu);
    const flatMenu: any[] = flatMapDepth(initMenu, duplicate, 2);
    const checkKey = menuKey ?? flatMenu[0]?.key;
    const menuItem = flatMenu.find((item: any) => item.key == checkKey);
    !menuKey && setCurrent(menuItem?.key);
    setIntroduce(menuItem?.introduce);
    setIntroduceImg(menuItem?.img);
  };
  const tabsClick = (item: any) => {
    setActive(item.key);
    setData(item.key);
  };

  const onClick: MenuProps["onClick"] = (e: any) => {
    setCurrent(e.key);
  };

  useEffect(() => {
    const tabItem = list.find((item) => item.key == tabActive);
    if (tabItem) {
      setActive(tabActive);
      setData(tabActive);
    }
  }, [tabActive]);

  useEffect(() => {
    setData(active, current);
  }, [current]);

  useEffect(() => {
    setData(list[0].key);
  }, []);
  return (
    <div className={prefix}>
      <div className={`${prefix}-bar-wrap`}>
        {list.map((item) => {
          return (
            <div
              key={item.key}
              className={`${prefix}-bar ${active == item.key && list?.length > 1 ? "on" : ""}`}
              style={{ width: item.barWidth }}
              onClick={() => tabsClick(item)}
            >
              {
                isShowImg && <div className={`${prefix}-bar-img`}>
                <img src={item.tab_img} alt="" style={{ width: item.imgWidth, height: item.imgHeight }} />
              </div>
              }
              

              <span className={`${prefix}-bar-text`}>{item.title}</span>
            </div>
          );
        })}
      </div>
      {menu?.length ? (
        <div className={`${prefix}-content-wrap`} style={{ backgroundImage: `url(${ecological.module_tabs_bg_img})` }}>
          <div className={`${prefix}-content-menu`}>
            <Menu
              onClick={onClick}
              mode="inline"
              items={menu}
              selectedKeys={[current]}
              className={`${prefix}-menu-inner`}
            />
            <div className={`${prefix}-content-menu-btns`}>
              {btnList.map((item) => {
                return (
                  <Button key={item.key} href={item.url} target="_blank" disabled={!item.url}>
                    {item.label}
                  </Button>
                );
              })}
            </div>
          </div>
          <div className={`${prefix}-content-introduce`}>
            <div className={`${prefix}-introduce-text`}>{Parser(introduce)}</div>
            <img src={introduceImg} alt="" className={`${prefix}-introduce-img`} />
          </div>
        </div>
      ) : (
        <div
          className={`${prefix}-content-empty`}
          style={{ backgroundImage: `url(${ecological.module_tabs_empty_bg_img})` }}
        >
          {emptyText}
          <div>{stay_tuned}</div>
        </div>
      )}
    </div>
  );
};
export default ModuleTabs;
